import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import GridOptionsCard from './GridOptions';
import GridColumnCard from './GridColumn';
import OneColumnWidthCard from './OneColumnWidth';
import VerticalAlignCard from './VerticalAlign';
import HorizontalAlignCard from './HorizontalAlign';
import NestingColCard from './NestingColumn';
import OrderCard from './Order';
import OffsetCard from './Offset';

const GridContainer = () => {
  return (
    <Container className='grid-wrrapper ' fluid={true}>
      <Breadcrumbs pageTitle='Grid' parent='Ui Kits' title='Grid' />
      <Row>
        <GridOptionsCard />
        <GridColumnCard />
        <OneColumnWidthCard />
        <VerticalAlignCard />
        <HorizontalAlignCard />
        <NestingColCard />
        <OrderCard />
        <OffsetCard />
      </Row>
    </Container>
  );
};

export default GridContainer;
